import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    DataTableSelectionBarContextType,
    DataTableSelectionContextType,
    DataTableContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const DataTableContext = createContext<DataTableContextType | undefined>(undefined);

export const DataTableSelectionContext = createContext<DataTableSelectionContextType | undefined>(undefined);

export const DataTableSelectionBarContext = createContext<DataTableSelectionBarContextType | undefined>(undefined);

export const useDataTableContext = ({
    part
}: {
    part: string;
}): DataTableContextType | undefined => {
    const context = useContext(DataTableContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `DataTable.${part}: must be rendered inside <DataTable>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};

export const useDataTableSelectionContext = (): DataTableSelectionContextType | undefined => {
    return useContext(DataTableSelectionContext);
};

export const useDataTableSelectionBarContext = (): DataTableSelectionBarContextType | undefined => {
    return useContext(DataTableSelectionBarContext);
};
